"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingMobile = exports.HeadingDesktop = void 0;
var _react = _interopRequireDefault(require("react"));
var _decorators = require("../../decorators");
var _styles = require("./styles");
var _excluded = ["children", "ellipsis", "maxLines", "device", "onClick", "size", "tag", "dataCy"]; //helpers
//styled-components
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var HeadingBase = (0, _decorators.styleable)(function (_ref) {
  var children = _ref.children,
    ellipsis = _ref.ellipsis,
    maxLines = _ref.maxLines,
    device = _ref.device,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'h2' : _ref$tag,
    dataCy = _ref.dataCy,
    forwardedProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = _styles.Heading.withComponent(tag);
  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    device: device,
    ellipsis: ellipsis,
    maxLines: maxLines,
    onClick: onClick,
    size: size,
    "data-cy": dataCy
  }, forwardedProps), children);
});
var HeadingDesktop = exports.HeadingDesktop = (0, _decorators.styleable)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(HeadingBase, _extends({
    device: "desktop"
  }, props));
});
var HeadingMobile = exports.HeadingMobile = (0, _decorators.styleable)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(HeadingBase, _extends({
    device: "mobile"
  }, props));
});
//# sourceMappingURL=index.js.map